import React from "react";
import config from 'config'

const defaultURI = `${config.apiGateway.URL}/${config.apiGateway.DEFAULT_VERSION}`;

function Logo(props) {
  return (
    <div className={props.logoStyle} style={{height:"125px"}}>
      {props.smallLogo ? (
        <img src={`${defaultURI}/Me/TenantLogo/sqr`} alt="logo" id="small-logo" />
      ) : (
        <img src={`${defaultURI}/Me/TenantLogo/rect`} alt="logo" id="logo" style={{maxWidth:"250px"}} />
      )}
    </div>
  );
}

export default Logo;
